// useLenis.ts
import { ref } from 'vue'
import Lenis from '@studio-freight/lenis'

const lenisInstance = ref<Lenis | null>(null)

export function setLenis(lenis: Lenis) {
    lenisInstance.value = lenis
}

export function useLenis() {
    return lenisInstance
}
